var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "", left: "", "close-on-content-click": false },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function({ on }) {
            return [
              _vm.documentExists || _vm.documentsNumber
                ? _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.getItems.apply(null, arguments)
                          }
                        }
                      },
                      on
                    ),
                    [
                      _c("display-icon-badge-tooltip", {
                        staticClass: "mr-2",
                        attrs: {
                          "badge-number": _vm.documentsNumber,
                          icon: "mdi-file",
                          "tooltip-text": "Documents liés"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _vm.items.length
        ? _c(
            "v-list",
            [
              _vm._l(_vm.items, function(item) {
                return _c(
                  "v-list-item",
                  {
                    key: item.id,
                    on: {
                      click: function($event) {
                        return _vm.download(item)
                      }
                    }
                  },
                  [
                    _vm.downloading === item.id
                      ? _c(
                          "v-list-item-title",
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                size: "20",
                                width: "2",
                                color: "light-blue"
                              }
                            })
                          ],
                          1
                        )
                      : _c("v-list-item-title", [_vm._v(_vm._s(item.title))])
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.hasMore > 0
                ? _c(
                    "v-list-item",
                    [
                      _c("v-list-item-title", [
                        _vm._v("et " + _vm._s(_vm.hasMore) + " autres")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _c(
            "v-list",
            [
              _c(
                "v-list-item",
                [
                  _c("v-list-item-title", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.isLoading
                            ? "Chargement des documents ..."
                            : "Aucun document n'a été retrouvé."
                        ) +
                        "\n      "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }